import React, { useMemo, useRef } from 'react';
import ReactQuill, { Quill } from 'react-quill';
import './quill.css';
import './quill';
import ImageResize from 'quill-image-resize-module-react';
Quill.register('modules/imageResize', ImageResize);

// 주) Toolbar의 tooltip은 text-editor.scss 파일에서 설정합니다.
const TextEditor = ({ className, value, onChange }) => {
    const quillRef = useRef(null);
    const modules = useMemo(() => {
        return {
            toolbar: {
                container: [
                    ['bold', 'italic', 'underline', 'strike'], // toggled buttons
                    ['blockquote', 'code-block'],

                    [{ header: 1 }, { header: 2 }], // custom button values
                    [{ script: 'sub' }, { script: 'super' }], // superscript/subscript

                    [{ list: 'ordered' }, { list: 'bullet' }],
                    [{ indent: '-1' }, { indent: '+1' }], // outdent/indent

                    // [{ direction: 'rtl' }], // text direction

                    [{ size: ['small', false, 'large', 'huge'] }], // custom dropdown
                    [{ header: [1, 2, 3, 4, 5, 6, false] }],

                    [{ color: [] }, { background: [] }], // dropdown with defaults from theme
                    [{ align: [] }],
                    ['link', 'image'],
                    ['clean'], // remove formatting button
                ],
            },
            imageResize: {
                modules: ['Resize', 'DisplaySize'],
            },
        };
    }, []);

    return (
        <div className={className}>
            <ReactQuill
                ref={quillRef}
                modules={modules}
                theme='snow'
                value={value}
                onChange={onChange}
                placeholder='내용을 입력해 주세요.'
            />
        </div>
    );
};

export default TextEditor;
